module.exports = __webpack_public_path__ + "static/anda-83329c796e543a560176c1ce106bdcd9.png";